import axios from 'axios'
import { getHeaders } from 'Modules/util'
import { map, reject, propEq } from 'ramda'

const url = process.env.REACT_APP_API

export const GET_LIST = 'paymentOrders/expense/GET_LIST'
export const GET_PROCESING_LIST = 'paymentOrders/expense/GET_PROCESING_LIST'
export const GET_PAID_LIST = 'paymentOrders/expense/GET_PAID_LIST'
export const GET_REJECTED_LIST = 'paymentOrders/expense/GET_REJECTED_LIST'
export const DELETE_ORDER = 'paymentOrders/expense/DELETE_ORDER'
export const CREATE_ORDER = 'paymentOrders/expense/CREATE_ORDER'
export const UPDATE_ORDER = 'paymentOrders/expense/UPDATE_ORDER'
export const GET_ORDER = 'paymentOrders/expense/GET_ORDER'
export const ADD_INSTALLMENT = 'paymentOrders/expense/ADD_INSTALLMENT'
export const GET_INSTALLMENTS = 'paymentOrders/expense/GET_INSTALLMENTS'
export const AUTHORIZE_INSTALLMENT = 'paymentOrders/expense/AUTHORIZE_INSTALLMENT'
export const END_ORDER_EDIT = 'paymentOrders/expense/END_ORDER_EDIT'
export const DELETE_INSTALLMENT = 'paymentOrders/expense/DELETE_INSTALLMENT'
export const IS_FETCHING_WALLET_GASOLINE = 'paymentOrders/expense/IS_FETCHING_WALLET_GASOLINE'
export const IS_FETCHING_WALLET_GASOLINE_COMPLETE = 'paymentOrders/expense/IS_FETCHING_WALLET_GASOLINE_COMPLETE'

const initialState = {
  list: {
    data: [],
  },
  paidList: {
    data: [],
  },
  procesingList: {
    data: [],
  },
  rejectedList: {
    data: [],
  },
  expenseOrder: {},
  installments: {
    data: [],
  },
  isFetchingexpense: false
}

export default (state = initialState, action) => {
  switch (action.type) {

    case CREATE_ORDER:
    case UPDATE_ORDER:
    case GET_ORDER:
    case GET_LIST:
    case GET_PAID_LIST:
    case GET_REJECTED_LIST:
    case GET_PROCESING_LIST:
    case GET_INSTALLMENTS:
      return { ...state, ...action.payload }
    case ADD_INSTALLMENT:
      return {
        ...state,
        installments: { data: state.installments.data.concat(action.payload) }
      }
    case AUTHORIZE_INSTALLMENT:
      let mapper = map(it => {
        if (it.id === action.payload.idInstallment) {
          it.estatus = action.payload.data.estatus
          it.estatusTexto = action.payload.data.estatusTexto
        }
        return it
      })

      return {
        ...state,
        installments: { data: mapper(state.installments.data) }
      }
    case DELETE_ORDER:
      const { data, ...meta } = state.list
      return {
        ...state, list: {
          data: data.map(it => {
            if (it.id === action.payload.id) {
              return action.payload
            }
            return it
          })
        },
        ...meta,
      }
    case END_ORDER_EDIT:
      return initialState
    case DELETE_INSTALLMENT:
      return {
        ...state,
        installments: { data: reject(propEq('id', action.payload))(state.installments.data) }
      }
    case IS_FETCHING_WALLET_GASOLINE:
      return { ...state, isFetchingexpense: true }
    case IS_FETCHING_WALLET_GASOLINE_COMPLETE:
      return { ...state, isFetchingexpense: false }
    default:
      return state
  }
}

export const isFetchingexpense = () => ({
  type: IS_FETCHING_WALLET_GASOLINE
})

export const isFetchingexpenseComplete = () => ({
  type: IS_FETCHING_WALLET_GASOLINE_COMPLETE
})

export const getList = (params) => {
  const headers = getHeaders()
  return dispatch => {
    dispatch(isFetchingexpense())
    return axios.post(`${url}/payment-order-expense/search`, params, { headers })
      .then(({ data }) => {
        dispatch(isFetchingexpenseComplete())
        dispatch({
          type: GET_LIST,
          payload: { list: data }
        })
      })
  }
}
export const getRejectedList = (params) => {
  const headers = getHeaders()
  return dispatch => {
    dispatch(isFetchingexpense())
    return axios.get(`${url}/payment-order-expense/status/rejected`, { headers, params })
      .then(({ data }) => {
        dispatch(isFetchingexpenseComplete())
        dispatch({
          type: GET_REJECTED_LIST,
          payload: { rejectedList: data }
        })
      })
  }
}

export const getPaidList = (params) => {
  const headers = getHeaders()
  return dispatch => {
    dispatch(isFetchingexpense())
    return axios.get(`${url}//payment-order-expense/status/paid`, { headers, params })
      .then(({ data }) => {
        dispatch(isFetchingexpenseComplete())
        dispatch({
          type: GET_PAID_LIST,
          payload: { paidList: data }
        })
      })
  }
}

export const getProcesingList = (params) => {
  const headers = getHeaders()
  return dispatch => {
    dispatch(isFetchingexpense())
    return axios.get(`${url}/payment-order-expense/status/in-process`, { headers, params })
      .then(({ data }) => {
        dispatch(isFetchingexpenseComplete())
        dispatch({
          type: GET_PROCESING_LIST,
          payload: { procesingList: data }
        })
      })
  }
}

export const deleteOrder = (orderId) => {
  const headers = getHeaders()
  return dispatch => {
    return axios.delete(`${url}/payment-order-expense/${orderId}`, { headers })
      .then(({ data }) => {
        dispatch({
          type: DELETE_ORDER,
          payload: data,
        })
        return data
      })
  }
}

export const createOrder = (order) => {
  const headers = getHeaders()
  return dispatch => {
    return axios.post(`${url}/payment-order-expense/`, order, { headers })
      .then(({ data }) => {
        dispatch({
          type: CREATE_ORDER,
          payload: { expenseOrder: data }
        })
        return data
      })
  }
}

export const updateOrder = order => {
  const headers = getHeaders()
  return dispatch => {
    return axios.put(`${url}/payment-order-expense/${order.id}`, order, { headers })
      .then(({ data }) => {
        dispatch({
          type: UPDATE_ORDER,
          payload: { expenseOrder: data }
        })
        return data
      })
  }
}

export const getOrder = (id) => {
  const headers = getHeaders()
  return dispatch => {
    return axios.get(`${url}/payment-order-expense/${id}`, { headers })
      .then(({ data }) => {
        dispatch({
          type: GET_ORDER,
          payload: { expenseOrder: data }
        })
        return data
      })
  }
}

export const addInstallment = (order, data) => {
  const headers = getHeaders()
  return dispatch => {
    return axios.post(`${url}/payment-order-expense/registerPayment/${order}`, data, { headers })
      .then(({ data }) => {
        dispatch({
          type: ADD_INSTALLMENT,
          payload: data,
        })
      })
  }
}

export const getInstallments = order => {
  const headers = getHeaders()
  return dispatch => {
    return axios.post(`${url}/payment-order-expense/deferred/${order}`, {}, { headers })
      .then(({ data }) => {
        dispatch({
          type: GET_INSTALLMENTS,
          payload: { installments: { data } },
        })
      })
  }
}

export const authorizeInstallment = ({ idOrder, idInstallment, ...data }) => {
  const headers = getHeaders()
  return dispatch => {
    return axios.post(`${url}/authorize-payment/${idOrder}/${idInstallment}`, data, { headers })
      .then(({ data }) => {
        dispatch({
          type: AUTHORIZE_INSTALLMENT,
          payload: { order: data, idInstallment, data },
        })
        return data
      })
  }
}

export const endOrderEdit = () => {
  return {
    type: END_ORDER_EDIT
  }
}

export const deleteInstallment = (idOrder, idInstallment) => {
  const headers = getHeaders()
  return dispatch => {
    return axios.delete(`${url}/payment-order-expense/deletePayment/${idOrder}/${idInstallment}`, { headers })
      .then(({ data }) => {
        dispatch({
          type: DELETE_INSTALLMENT,
          payload: idInstallment,
        })
      })
  }
}